import React from "react";
import { Two } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
   return <ShreeDayTable staticData={Two} chartData={chartData} />;
 
};

export default ShreeDay;
